import {initWebComponent} from "@/helpers/web-component-helper";
import {activateUserSessionByID, getUserSessionByID, updateSession} from "@/helpers/user-session-helper";

export class BookmarkUserSessionUpdateButtonComponent extends HTMLElement {
    constructor(){
        super();

        const id = this.getAttribute('data-id')

        const template = document.createElement('template');

        template.innerHTML = `<button class="btn btn-sm borderless icon-btn popper-header">
              <i class="fa fa-check"></i>
              <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                 Bookmark opslaan
                <div class="arrow" data-popper-arrow=""></div>
              </div>
            </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            updateSession(id)
        })
    }
}
